export default {
	name: 'Favorite'
};